import React, { createContext } from "react"
import TranslationController from "./controller"

export const TranslationContext = createContext(new TranslationController())

export default function TranslationProvider(props) {
  const context = new TranslationController()

  context.setLanguages(props.languages)
  context.setTranslations(props.translations)

  context.setSelectedLanguage(props.selectedLanguage ?? props.languages[0])

  return (
    <TranslationContext.Provider value={context}>
      {props.children}
    </TranslationContext.Provider>
  )
}